module.exports = __webpack_public_path__ + "img/portrait-045.5d8248cd.jpg";